import React, { useEffect, useState } from 'react';
import { BsFacebook } from 'react-icons/bs';
import { FiArrowUpCircle } from 'react-icons/fi';
import { RiInstagramFill } from 'react-icons/ri';
import { SiGithub } from 'react-icons/si';
import './footer.css';

const Footer = () => {
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  useEffect(() => {
    // Update the current year on component mount
    setCurrentYear(new Date().getFullYear());
  }, []);

  return (
    <footer>
      <div className="footer-container container">
        <div>
          <h2>FIND ME ON</h2>

          <div className="footer-social">
            <div className="footer-social">
              <a href="https://github.com/Yacine166" target="_blank" rel="noopener noreferrer">
                <SiGithub className="icon-footer" />
              </a>
              <a href="https://facebook.com/ayacine16" target="_blank" rel="noopener noreferrer">
                <BsFacebook className="icon-footer" />
              </a>
              <a href="https://instagram.com/yacine.prog" target="_blank" rel="noopener noreferrer">
                <RiInstagramFill className="icon-footer" />
              </a>
            </div>
          </div>
          <h5 className="text-light">Feel free to connect with me</h5>
        </div>
        <div className="up">
          <a href="#" role="button">
            <FiArrowUpCircle />
          </a>
        </div>
      </div>
      <div className="copyright text-light">
        <h5 className="designed">Developed by <strong style={{ borderBottom: '1.5px solid #fff', }}>Aoumara Yacine</strong>&nbsp;&copy; {currentYear}</h5>
      </div>

    </footer>
  );
};

export default Footer;
